module.exports = __webpack_public_path__ + "img/6.f3ef017.jpg";